import { TypePolicies } from '@apollo/client/cache'

export const typePolicies: TypePolicies = {
  Cart: {
    fields: {
      lineItems: {
        merge(_existing, incoming) {
          return incoming
        },
      },
      discountCodes: {
        merge(_existing, incoming) {
          return incoming
        },
      },
    },
  },

  LineItem: {
    fields: {
      discountedPricePerQuantity: {
        merge(_existing, incoming) {
          return incoming
        },
      },
      taxedPrice: {
        merge(_existing, incoming) {
          return incoming
        },
      },
    },
  },
  Query: {
    fields: {
      me: {
        merge(existing, incoming) {
          // We need to merge this, otherwise me.customer will overwrite me.carts etc.
          return { ...existing, ...incoming }
        },
      },
      reviews: {
        // Don't cache separate results based on
        // any of this field's arguments.
        keyArgs: false,
        // Concatenate the incoming list items with
        // the existing list items.
        merge(_, incoming) {
          return incoming
        },
      },
    },
  },
}
